























































import NoResults from "@/components/ui/NoResults.vue";
import { Component } from "vue-property-decorator";
import BaseInternalValorization from "@/components/pages/valorizations/internal/observatory/BaseInternalValorization.vue";

@Component({
  components: {
    NoResults
  }
})
export default class BaseInternalTableValorization extends BaseInternalValorization {}
